<template>
  <el-cascader
    v-loading="page.loading"
    v-model="page.selected"
    :options="page.areaList"
    :placeholder="placeholder"
    :props="{ value: 'id', label: 'name' }"
    @change="addressChange"
    clearable
  />
</template>
<script setup>
import { defineProps, reactive, getCurrentInstance, defineEmits, watch } from 'vue'
import { treeDataTranslate } from '@/utils/index'
const props = defineProps({
  modelValue: { type: String },
  placeholder: { type: String, default: '请选择' }
})
const emit = defineEmits(['change', 'update:modelValue'])
const { proxy } = getCurrentInstance()
const page = reactive({
  areaList: [],
  loading: false,
  selected: []
})
const getData = async () => {
  page.loading = true
  let res = await proxy.$http.get('/app/custClient/region/listAll')
  if (res.code === 0) {
    page.areaList = treeDataTranslate(res.data, 'id', 'pid', 'name')
  }
  page.loading = false
}
getData()
const addressChange = (arr) => {
  let res = JSON.stringify(arr)
  emit('update:modelValue', res)
  emit('change', res)
}
watch(
  () => props.modelValue,
  (newVal) => {
    if (newVal && newVal != '') {
      page.selected = JSON.parse(newVal)
    } else {
      page.selected = []
    }
  },
  { immediate: true }
)
</script>
